<template>
    <m-main-layout>
<!--        <base-button slot="right-btn" @click.native="$router.push({path:'/ads/cate/list'})" rule="/ads/cate/list">返回广告位</base-button>-->
        <add-button slot="right-btn" label="添加" v-if="dataList.length > 0" @click.native="$router.push({path:'/user/vip/add'})" rule="/user/vip/add"></add-button>
        <div class="page-content-main">
            <el-table :data="dataList" default-expand-all style="width: 100%" :row-key="(row)=>{return row.is_spec && row.is_spec === 1 ? 'cell_'+row.id : 'sub_'+row.id}" :tree-props="{children: 'child'}" :indent="30" v-if="dataList.length > 0">
                <el-table-column
                        prop="title"
                        label="标题">
                </el-table-column>
                <el-table-column
                        prop="icon"
                        label="图标">
                    <template slot-scope="scope">
                        <img :src="scope.row.icon.indexOf('http://') >= 0 || scope.row.icon.indexOf('https://') >= 0 ? scope.row.icon+'!thumb' : $config.assetsUrl+scope.row.icon" height="40" v-if="scope.row.icon"/>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="bg"
                        label="背景">
                    <template slot-scope="scope">
                        <img :src="$config.assetsUrl + scope.row.bg" height="40" v-if="scope.row.bg_type === 'image'"/>
                        <span v-if="scope.row.bg_type === 'color'" :style="'display: inline-block;width:30px;height:30px;background: '+scope.row.bg"></span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="goods_percent"
                        label="购物折扣率">
                    <template slot-scope="scope">
                        {{scope.row.goods_percent}}%
                    </template>
                </el-table-column>
                <el-table-column
                        prop="goods_percent"
                        label="赠送购物券">
                    <template slot-scope="scope">
                        {{scope.row.quan_count}}元/{{scope.row.quan_time === 'week' ? '每周' : '每月'}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="jiang_times"
                        label="抽奖次数(次)">
                </el-table-column>
                <el-table-column
                        prop="crowd_times"
                        label="同时众筹次数(次)">
                </el-table-column>
                <el-table-column
                        prop="crowd_percent"
                        label="众筹分润比例(%)">
                </el-table-column>
                <el-table-column
                        prop="is_default"
                        label="是否默认等级" style="font-size:12px;">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.is_default === 1 ? 'success' : 'danger'" disable-transitions>{{scope.row.is_default === 0 ? '否' : '是'}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="sort"
                        label="排序">
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="状态" style="font-size:12px;">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.state === 1 ? 'success' : 'danger'" disable-transitions>{{scope.row.state === 0 ? '禁用' : '可用'}}</el-tag>
                    </template>
                </el-table-column>
<!--                <el-table-column-->
<!--                        prop="create_time"-->
<!--                        label="创建时间">-->
<!--                    <template slot-scope="scope">-->
<!--                        {{scope.row.create_time === 0 ? '—' : $moment.unix(scope.row.create_time).format('YYYY-M-D HH:mm:ss')}}-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        prop="update_time"-->
<!--                        label="修改时间">-->
<!--                    <template slot-scope="scope">-->
<!--                        {{scope.row.update_time === 0 ? '—' : $moment.unix(scope.row.update_time).format('YYYY-M-D HH:mm:ss')}}-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column align="right" min-width="170">
                    <template slot-scope="scope">
                        <base-button @click.native="$router.push({path:'/user/vip/price/list/',query:{vip_id:scope.row.id}})" rule="/user/vip/price/list">查看价格</base-button>
                        <edit-button @click.native="$router.push({path:'/user/vip/edit/'+scope.row.id})" rule="/user/vip/edit"></edit-button>
                        <del-button @click.native="del(scope.row.id)" rule="/user/vip/del"></del-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="text-center null-data f14 info" v-else>
                还没有数据，<add-button slot="right-btn" @click.native="$router.push({path:'/user/vip/add'})" rule="/user/vip/add" label="立即添加"></add-button>
            </div>
            <div class="text-center padding-top-bottom-20" v-if="dataList.length > 0">
                <el-pagination
                        background
                        layout="total,prev, pager, next"
                        :page-size="pageSize"
                        :current-page.sync="page"
                        :total="totalCount"
                        @current-change="pageChange">
                </el-pagination>
            </div>
        </div>
    </m-main-layout>
</template>

<script>
    export default {
        name: "GoodsSpecList",
        data(){
            return{
                dataList: [],
                totalPage:0,
                totalCount:0,
	            pageSize:20,
                page:1,
                cateId:0,
	            cateDetail:{}
            }
        },
        created(){
        	this.cateId = this.$route.query.cateId ? this.$route.query.cateId : 0;
        },
        methods:{
            getList(){
                let _this = this;
                this.dataList = [];
                this.$http.httpPost({
                    url:'Vip/listPage',
                    datas:{page:this.page,pageSize:this.pageSize,cate_id:this.cateId,orderBy:'sort',sortBy:'asc'},
                    success:(res)=>{
	                    _this.dataList = res.list;
                        _this.totalPage = res.totalPage;
                        _this.totalCount = res.totalCount;
                    }
                });
            },
	        del(id) {
		        let _this = this;
		        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
		        }).then(() => {
			        this.$http.httpPost({
				        url:'Vip/del',
				        datas:{id:id},
				        success:(res)=>{
					        _this.getList();
				        }
			        });
		        }).catch(() => {
		        });
	        },
	        pageChange(page){
		        this.page = page;
		        this.getList();
	        },
        },
        mounted() {
            this.getList();
        }
    }
</script>
